// extracted by mini-css-extract-plugin
export default {"container":"CaseTags_container__wLkSR","chip":"CaseTags_chip__Lw92B","newTag":"CaseTags_newTag__YNltT","create":"CaseTags_create__jorjK"};